import { render, staticRenderFns } from "./certificate-jewel-table.vue?vue&type=template&id=f4fbb37c"
import script from "./certificate-jewel-table.vue?vue&type=script&lang=js"
export * from "./certificate-jewel-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports